import PropTypes from 'prop-types';
import React from 'react';

const InputText = ({
  type,
  name,
  label,
  value,
  error,
  onChange,
  placeholder,
  isDisabled,
  legend,
}) => {
  if (!name && !label && !onChange) {
    throw new Error('name, label and onChange properties are required');
  }
  return (
    <div className={'ccfp__content__form__input-text'}>
      <div
        className={`ccfp__content__form__input-text__label ${
          error ? 'ccfp__content__form__input-text__label--has-error' : ''
        }`}
      >
        <label htmlFor={name}>{label}</label>
      </div>
      <div
        className={`ccfp__content__form__input-text__input ${
          error ? 'ccfp__content__form__input-text__input--has-error' : ''
        }`}
      >
        <input
          type={`${type || 'text'}`}
          onChange={e => onChange(e)}
          name={name}
          id={name}
          value={value}
          placeholder={placeholder}
          disabled={isDisabled}
        />
        <p className={'error-text'}>{error}</p>
        <p className={'ccfp__content__form__input-text__legend'}>{legend}</p>
      </div>
    </div>
  );
};

InputText.propTypes = {
  type: PropTypes.oneOf(['text', 'number']),
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  isDisabled: PropTypes.bool,
  legend: PropTypes.string,
};

export default InputText;
